<template>
  <div class="item-unit-modal">
      <div class="card-body">
        <div class="form-group row">
            <div class="col-md-6">
              <label class="form-label">{{ $t('documents.note') }}</label>
              <p> {{note}}</p>
            </div>
        </div>
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeDocumernNoteModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required, minLength, maxLength, email, url, numeric,minValue,maxValue } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
        note: null,
        isLoading: false,
    }    
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ]),
  },
  created(){
  },
 validations: {
 },
  async mounted () {
    if (this.modalDataID) {
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
    resetFormData () {  
        this.note=null;
    },
    async setData () {
        this.note=this.modalData.custom_properties.note;

    },
    closeDocumernNoteModal () {
      this.resetModalData()
      this.resetFormData()
      this.closeModal()
    },
  }
}
</script>
